export default {
  title: 'ギフトカテゴリ',
  addFirstLevel: '一次カテゴリ追加',
  addSecondLevel: '二次カテゴリ追加',
  categoryName: 'カテゴリ名',
  addModal: '一次カテゴリ追加',
  editModal: 'カテゴリ編集',
  addSecondModal: '二次カテゴリ追加',
  required: 'カテゴリ名を入力してください',
};
